"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _genericPopupThemes = _interopRequireDefault(require("./generic-popup-themes"));

var _default = _propTypes.default.oneOf(Object.values(_genericPopupThemes.default));

exports.default = _default;